// package: common
// file: common/version.proto


export const Version = {
    encode(object) {
        const message = {};
        if (object.appVersion != null) {
            if (object.appVersion !== "") {
                message.appVersion = String(object.appVersion);
            }
        }
        if (object.binaryVersion != null) {
            if (object.binaryVersion !== "") {
                message.binaryVersion = String(object.binaryVersion);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            appVersion: "",
            binaryVersion: "",
        };

        if (message.appVersion != null) {
            object.appVersion = message.appVersion;
        }
        if (message.binaryVersion != null) {
            object.binaryVersion = message.binaryVersion;
        }
        return object;
    },
};


